import React from 'react';
import { ModalConfirmationProps } from '.';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { FiSave, FiEdit, FiAlertTriangle } from 'react-icons/fi';
import ModalWrapper from '../../elements/ModalWrapper';
import Button from '../../elements/Button';
import { Flex, Text } from '@mantine/core';

const ModalConfirmation: React.FC<ModalConfirmationProps> = ({
  isVisible,
  onCancel,
  onConfirm,
  loading,
  submitText = 'Submit',
  updateText = 'Update',
  description,
  title,
  type
}) => {
  const getModalContent = () => {
    switch (type) {
      case 'reset':
        return {
          title: title || 'Reset Data',
          icon: <FiEdit />,
          buttonText: updateText,
          description: description || 'Are you sure you want to reset this?'
        };
      case 'edit':
        return {
          title: title || 'Update Data',
          icon: <FiEdit />,
          buttonText: updateText,
          description: description || 'Are you sure you want to update this?'
        };
      case 'navigation':
        return {
          title: title || 'Unsaved Changes',
          icon: <FiAlertTriangle />,
          buttonText: 'Leave Page',
          description:
            description ||
            'You have unsaved changes. Are you sure you want to leave this page?'
        };
      default:
        return {
          title: title || 'Submit Data',
          icon: title === 'Not Available' ? null : <FiSave />,
          buttonText: submitText,
          description: description || 'Are you sure you want to submit this?'
        };
    }
  };

  const modalContent = getModalContent();

  return (
    <ModalWrapper
      title={modalContent.title}
      isVisible={isVisible}
      onClose={onCancel}
    >
      <div className="wrapper-modal-submit">
        <div className="wrapper-modal-submit__content">
          <Text size="md" mb={16}>
            {modalContent.description}
          </Text>
          <Flex mt={16} gap={16} align="center" justify="flex-end">
            {title === 'Not Available' ? null : (
              <Button
                variant="error-beelajar"
                disabled={loading}
                onClick={onCancel}
              >
                {type === 'navigation' ? 'Stay on Page' : 'Cancel'}
              </Button>
            )}
            <Button
              disabled={loading}
              loading={loading}
              onClick={onConfirm}
              variant={'solid'}
            >
              {modalContent.icon} {modalContent.buttonText}
            </Button>
          </Flex>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ModalConfirmation;
